exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-search-input-container{margin:.5em;display:flex;justify-content:center}.user-search-input-container .search-button{margin-left:.5em}.loading-icon{padding:1em}", ""]);

// exports
